import { Typography } from "@mui/material"

type Props = {}

const DisplayNameLabel = (props: Props) => {
  return <Typography variant="body1">Display Name</Typography>
}

export default DisplayNameLabel
